import { animate } from 'animejs';
import globalVar from '../utils/globalVar'

class Module12Faq {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.dropdown = document.querySelectorAll('.module-12-faq .dropdown_title');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.dropdown.length; i++) {
            cache.dropdown[i].addEventListener('click',toggleCol);
        }
    };

    let toggleCol = function() {
        const col = this.closest('.dropdown');
        
        if(!col.classList.contains('active')) {
            const parent = col.closest('.dropdown_container');
            const active = parent.querySelector('.dropdown.active');
            if (active) {
                active.classList.remove('active');
                animate(active.querySelector('.dropdown_content'), {
                    duration: 600,
                    height: 0,
                    ease: 'inOutCubic',
                    onComplete: function() {
                        active.querySelector('.dropdown_content').style.display = "none";
                    }
                });
            }

            col.classList.add('active');
            const col_content = col.querySelector('.dropdown_content');
            col_content.style.display = "block";
            col_content.style.height = "auto";
            const height = col_content.offsetHeight;
            col_content.style.height = 0;

            animate(col_content, {
                duration: 600,
                height: height,
                ease: 'inQuad',
                onComplete: function() {
                    document.querySelector('body').classList.add('scroll');
                    animate(globalVar.scrollElement, {
                        scrollTop: (globalVar.scrollElement.scrollTop + col.getBoundingClientRect().top),
                        duration: 600,
                        ease: 'outQuad',
                        onComplete: function() {
                            document.querySelector('body').classList.remove('scroll');
                        }
                    });
                }
            });
        } else {
            col.classList.remove('active');
            animate(col.querySelector('.dropdown_content'), {
                duration: 600,
                height: 0,
                ease: 'inOutCubic',
                onComplete: function() {
                    col.querySelector('.dropdown_content').style.display = "none";
                }
            });
        }
    }

    initFunc();
  };
}
export { Module12Faq }